import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { Target } from '../TargetsContext/types'
import { HelpMessage } from 'utils/constants'

export function useExpand(): ExpandOptions<Target> {
  return {
    expandable: ({ percentages }) => !!percentages.length,
    render: ({ percentages }) => ({
      additionalInfo: [
        {
          label: 'Mix Design Percentages',
          type: 'tags',
          help: HelpMessage.Materials.Asphalt.MixDesignPercentages,
          tags: percentages
            .filter(({ mixDesign: { deleted } }) => !deleted)
            .map(({ mixDesign: { mixDesignNumber, active }, percentage }) => ({
              text: `${mixDesignNumber} : ${percentage}%`,
              strikethrough: !active,
            })),
        },
      ],
    }),
  }
}
